"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var COLOR = '#3e7697';
var DefaultLink = _styledComponents["default"].a.withConfig({
  displayName: "Link__DefaultLink",
  componentId: "sc-1ap3454-0"
})(["color:", ";"], COLOR);
var _default = DefaultLink;
exports["default"] = _default;
//# sourceMappingURL=Link.js.map